import * as yup from 'yup';

export const ResetPasswordSchema = yup.object().shape({
  password: yup.string().min(5, 'Password must be at least 5 characters').required('Password is required field'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required'),
});
